import React from 'react';
import classnames from 'classnames';
import Isvg from 'react-inlinesvg';

import tick from 'app/images/icons/tick.svg';

interface ICheckboxProps {
  checked: boolean;
  radio: boolean;
  onClick: Function;
  className: string;
}

export default class Checkbox extends React.Component<ICheckboxProps> {
  static defaultProps: ICheckboxProps = {
    checked: false,
    radio: false,
    onClick: undefined,
    className: '',
  };

  render(): React.ReactNode {
    return (
      <div
        className={classnames(
          'checkbox-square',
          { checked: this.props.checked },
          { radio: this.props.radio },
          this.props.className,
        )}
        onClick={this.props.onClick}
      >
        {this.props.checked && !this.props.radio && <Isvg className="tick" src={tick} />}
        {this.props.checked && this.props.radio && <div className="radio-circle" />}
      </div>
    );
  }
}
